// 19.1.2.7 Object.getOwnPropertyNames(O)
require('./_object-sap')('getOwnPropertyNames', function () {
  return require('./_object-gopn-ext').f;
});



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.1@core-js/modules/es6.object.get-own-property-names.js
// module id = 321
// module chunks = 0